<template>
  <div class="">
    <div class="complete__table--body">
      <device
          v-for="(device, index) in devices"
          :key="index"
          v-bind:deviceName.sync="device.deviceName"
          v-bind:qty.sync="device.qty"
          v-bind:wattage.sync="device.wattage"
          v-bind:simultaneous.sync="device.simultaneous"
          v-bind:minutes.sync="device.minutes"
          v-bind:verify="verifying"
          @on-delete="deleteDevice(device)"
      />
    </div>
    <div class="mt-2 mb-3">
      <create-device @on-new-device="addDevice()"/>
    </div>
    <div class="mt-5 mb-3">
      <button
          @click.prevent="saveDevices()"
          class="btn btn--red btn--arrow"
      >
        Aanvullende info versturen
      </button>
    </div>
    <notifications group="devices"/>

  </div>
</template>

<script>
const defaultDevice = {
  qty: 1,
  deviceName: '',
  wattage: 0,
  simultaneous: false,
  minutes: 0
}

var ES6Promise = require("es6-promise");
ES6Promise.polyfill();
const axios = require('axios').default;
import Device from "./Device.vue";
import CreateDevice from "./CreateDevice.vue";
import Notifications from "vue-notification";
// import Vuelidate from 'vuelidate'
import Vue from 'vue'

Vue.use(Notifications);
// Vue.use(Vuelidate);

export default {
  props: {
    reference: String,
  },
  data() {
    return {
      verifying: false,
      devices: [
        {...defaultDevice},
      ],
    };
  },
  methods: {
    addDevice() {
      this.devices.push({...defaultDevice});
    },
    deleteDevice(deletedDevice) {
      this.devices = this.devices.filter(device => device !== deletedDevice);
    },
    saveDevices() {
      let self = this;
      this.$emit('loading', true);
      this.verifying = true;

      let config = {};
      config['devices'] = this.devices;
      config['reference'] = this.reference;
      let formData = self.getFormDataFromArray(config)

      axios.post('/api/saveDevices/', formData)
          .then(response => {
            if (response.data.success) {
              this.sent = true;
              window.location = response.data.redirect;
            } else {
              window.setTimeout(function () {
                self.$emit('loading', false)
              }, 200)
            }
          })
          .catch((error) => {
            if (typeof error.response.data.message === 'string') {
              self.$notify(
                  {
                    group: "devices",
                    title: "Fout opgetreden",
                    text: error.response.data.message,
                    type: 'error'
                  },
                  10000
              );
            }

            if (error.response.data.vars && error.response.data.vars.redirect && typeof error.response.data.vars.redirect === 'string') {
              window.setTimeout(function () {
                window.location = error.response.data.vars.redirect;
              }, 2000);
            } else {
              window.setTimeout(function () {
                self.$emit('loading', false)
              }, 200)
            }

          }).finally(() => {
      });
    },
    getFormDataFromArray: function (array) {
      let formData = new FormData();
      $.each(array, function (key, element) {
        if (typeof element === 'object') {
          let loopIndex = 0;
          $.each(element, function (subKey, subElement) {
          // for (const [subKey, subElement] of Object.entries(element)) {
            if (typeof subElement === 'object') {
              $.each(subElement, function (subsubKey, subsubElement) {
              // for (const [subsubKey, subsubElement] of Object.entries(subElement)) {
                formData.append(key + '[' + subKey + '][' + subsubKey + ']', subsubElement);
              });
            } else {
              formData.append(key + '[' + subKey + ']', subElement);
            }
            loopIndex++;
          });
        } else {
          formData.append(key, element);
        }

      })
      // for (const [key, element] of Object.entries(array)) {
      // }

      return formData;

    },

  },
  components: {Device, CreateDevice},
};
</script>

<style scoped lang="scss"></style>
